/**
 * @flow
 * @relayHash 863050de634b3e74ead5695b4ffab413
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FavoriteAction = "ADD" | "REMOVE" | "%future added value";
export type FavoritePageInput = {|
  page: string,
  name?: ?string,
  query?: ?string,
  type: string,
  userId: string,
  favoriteId?: ?string,
  action: FavoriteAction,
  clientMutationId?: ?string,
|};
export type ModifyFollowingItems_esMutationVariables = {|
  input: FavoritePageInput
|};
export type ModifyFollowingItems_esMutationResponse = {|
  +favoritePage: ?{|
    +user: ?{|
      +favorites: ?{|
        +totalResults: ?number,
        +numberOfPages: ?number,
      |}
    |}
  |}
|};
export type ModifyFollowingItems_esMutation = {|
  variables: ModifyFollowingItems_esMutationVariables,
  response: ModifyFollowingItems_esMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FavoritePageInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "FavoritePageInput!"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "favorites",
  "storageKey": null,
  "args": null,
  "concreteType": "favoritesConnection",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "numberOfPages",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ModifyFollowingItems_esMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoritePage",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoritePagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ModifyFollowingItems_esMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoritePage",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoritePagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ModifyFollowingItems_esMutation",
    "id": "app-buyer-misc/209.0.0-2019-03-26T14:04:46.491Z/ModifyFollowingItems_esMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a1eb7c83ac6596941dd6dbad2798e280';
module.exports = node;
